import { render, staticRenderFns } from "./GrBottomBackground.vue?vue&type=template&id=47f9e2ce&scoped=true&"
import script from "./GrBottomBackground.vue?vue&type=script&lang=ts&"
export * from "./GrBottomBackground.vue?vue&type=script&lang=ts&"
import style0 from "./GrBottomBackground.vue?vue&type=style&index=0&id=47f9e2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9e2ce",
  null
  
)

export default component.exports